import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ReportNameEnum } from '../enums/report-name.enum';
import { environment } from '../../environments/environment';
import { EndpointTypeEnum } from '../enums/endpoint-type.enum';
import { RGatewayRequest } from '../models/RGatewayRequest';
import { RequestTypeEnum } from '../enums/request-type.enum';
import { FormCode } from '../enums/form-code.enum';

@Injectable()
export class ReportService {
  constructor(private http: HttpClient) {}

  private formController = `${environment.reportGateway}`;
  private documentController = `${environment.reportGateway}/Document`;
  private settingsController = `${environment.reportGateway}/Settings`;

  public static openBlob(download, type: string): void {
    const blob = new Blob([download], { type: type });
    const obj = URL.createObjectURL(blob);
    const wind = window.open(obj, '_blank');
    wind.print();
  }

  public static downloadBlob(download, type: string, fileName): void {
    const blob = new Blob([download], { type: type });
    const obj = URL.createObjectURL(blob);
    const wind = window.document.createElement('a');
    wind.href = obj;
    wind.download = fileName;
    wind.click();
  }

  getPayload(
    filterString: string = null,
    entity: any = null,
    formCode: FormCode,
    reportName: ReportNameEnum,
    endpointType: EndpointTypeEnum,
    requestType: RequestTypeEnum = null
  ): RGatewayRequest {
    return {
      FilterString: filterString,
      Entity: entity,
      ReportName: reportName,
      EndpointType: endpointType,
      RequestType: requestType,
      FormCode: formCode,
    };
  }

  getSettingsPayload(
    reportName: ReportNameEnum,
    endpointType: EndpointTypeEnum,
    formCode: FormCode
  ): RGatewayRequest {
    return {
      EndpointType: endpointType,
      FilterString: '',
      Entity: null,
      RequestType: null,
      ReportName: reportName,
      FormCode: formCode,
    };
  }

  // Radi export poslatog modela u pdf ili excel u zavisnosti od ReportType-a prosledjenog u objektu.
  exportToDocument(requestModel: RGatewayRequest): Observable<any> {
    return this.http.post(this.documentController, requestModel, {
      responseType: 'arraybuffer',
    });
  }

  // Vraca samo data u json-u, druga metoda se koristi jer su razliciti responseType.
  getFormData(requestModel: RGatewayRequest): Observable<any> {
    return this.http.post(this.formController, requestModel);
  }

  getSettings(requestModel: RGatewayRequest): Observable<any> {
    return this.http.post(this.settingsController, requestModel);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/report.service.ts